<template>
    <div>
        <div class="md-col-2">
            <div class="td-card rounded border grey mb-2 pt-1">
                <error v-if="creditCardValidator.errors['expiry'] && cardToAdd.expiryMonth && cardToAdd.expiryYear"
                       :error="creditCardValidator.errors['expiry']">
                </error>
                <div class="td-banner danger" v-if="errorMessage">
                    <icon name="faTriangleExclamation" type="solid"></icon>
                    <p>{{ errorMessage }}</p>
                </div>

                <div class="mt-1">
                    <label class="td-label">Name on Card:</label>
                    <input :class="{'error': creditCardValidator.errors['name']}"
                           v-model="cardToAdd.name" type="text"
                           placeholder="e.g. John Doe"
                           @input="creditCardValidator.validate('name')" />
                    <error v-if="creditCardValidator.errors['name']" :error="creditCardValidator.errors['name']"></error>
                </div>
                <div class="ccard-code">
                    <div>
                        <label class="td-label">Number:</label>
                        <input v-model="cardToAdd.number" type="text" placeholder="e.g. 1234 5678 9012 3456"
                               :class="{'error': creditCardValidator.errors['number'] || creditCardValidator.errors['numberFinal'] || responseErrors['number']}"
                               @blur="creditCardValidator.validate('numberFinal')"
                               @input="creditCardValidator.validate('number');clearResponseErrors('number')" />
                        <error v-if="creditCardValidator.errors['number']" :error="creditCardValidator.errors['number']"></error>
                        <error v-if="creditCardValidator.errors['numberFinal']" :error="creditCardValidator.errors['numberFinal']"></error>
                        <error v-if="responseErrors['number']" :error="responseErrors['number']"></error>
                    </div>
                    <div class="code">
                        <label class="td-label">Security Code:</label>
                        <input :class="{'error': creditCardValidator.errors['securityCode'] || creditCardValidator.errors['codeFinal'] || responseErrors['code']}"
                               v-model="cardToAdd.securityCode" type="text" placeholder="e.g. 123"
                               @input="creditCardValidator.validate('securityCode');clearResponseErrors('code')" @blur="creditCardValidator.validate('codeFinal')" />
                    </div>
                </div>
                <error v-if="responseErrors['code']" :error="responseErrors['code']"></error>
                <error v-if="creditCardValidator.errors['codeFinal']" :error="creditCardValidator.errors['codeFinal']"></error>

                <div class="md-col-3">
                    <div>
                        <label class="td-label">Expiry Month:</label>
                        <select v-model="cardToAdd.expiryMonth" id="selectedMonth" name="selectedMonth" required
                                :class="[{'error': creditCardValidator.errors['expiryMonth']}, 'td-select']"
                                @change="creditCardValidator.validate('expiryMonth');creditCardValidator.validate('expiry')">
                            <option value="" disabled selected>Select month</option>
                            <option v-for="month in selectableMonths" :value="month" :key="month">{{ month }}</option>
                        </select>
                        <error v-if="creditCardValidator.errors['expiryMonth']" :error="creditCardValidator.errors['expiryMonth']"></error>
                    </div>
                    <div>
                        <label class="td-label">Expiry Year:</label>
                        <select v-model="cardToAdd.expiryYear" id="selectedYear" name="selectedYear" required
                                :class="[{'error': creditCardValidator.errors['expiryYear']}, 'td-select']"
                                @change="creditCardValidator.validate('expiryYear');creditCardValidator.validate('expiry')">
                            <option value="" disabled selected>Select year</option>
                            <option v-for="year in selectableYears" :value="year" :key="year">{{ year }}</option>
                        </select>
                        <error v-if="creditCardValidator.errors['expiryYear']" :error="creditCardValidator.errors['expiryYear']"></error>
                    </div>
                    <label class="td-checkbox-label td-text-mice">
                        Use as Primary Card
                        <input name="setCardPrimary" type="checkbox" v-model="cardToAdd.isPrimary" />
                        <span></span>
                    </label>
                </div>
            </div>

            <div class="td-card rounded border grey pt-1">
                <div class="mb-1">
                    <label class="td-label">Address:</label>
                    <input :class="[{'error': addressValidator.errors['line1'] || responseErrors['line1']}, 'td-input']"
                           v-model="address.line1" type="text" placeholder="Address Line 1"
                           @input="addressValidator.validate('line1');clearResponseErrors('address')" />
                    <error v-if="addressValidator.errors['line1']" :error="addressValidator.errors['line1']"></error>
                </div>
                <div class="my-1">
                    <label class="td-label">Address Line 2:</label>
                    <input class="td-input" v-model="address.line2" type="text" placeholder="Suite, Floor, Building, etc." />
                </div>

                <div class="my-1">
                    <label class="td-label">City:</label>
                    <input :class="[{'error': addressValidator.errors['city']}, 'td-input']"
                           v-model="address.city" type="text" placeholder="City" @input="addressValidator.validate('city')" />
                    <error v-if="addressValidator.errors['city']" :error="addressValidator.errors['city']"></error>
                </div>
                <div class="sm-col-3 my-1">
                    <div>
                        <label class="td-label">State/Prov:</label>
                        <select v-model="address.regionCode" id="regionCode" name="regionCode" required
                                :class="[{'error': addressValidator.errors['regionCode']}, 'td-select']"
                                @change="addressValidator.validate('regionCode')">
                            <option value="" disabled selected>Select region</option>
                            <option v-for="region in selectableRegions" :value="region" :key="region">{{ region }}</option>
                        </select>
                        <error v-if="addressValidator.errors['regionCode']" :error="addressValidator.errors['regionCode']"></error>
                    </div>
                    <div>
                        <label class="td-label">Country:</label>
                        <select v-model="address.countryCode" id="countryCode" name="countryCode" required
                                :class="[{'error': addressValidator.errors['countryCode']}, 'td-select']"
                                @change="changeCountry();addressValidator.validate('countryCode')">
                            <option value="" disabled selected>Select country</option>
                            <option value="CA">Canada</option>
                            <option value="US">United States</option>
                        </select>
                        <error v-if="addressValidator.errors['countryCode']" :error="addressValidator.errors['countryCode']"></error>
                    </div>
                    <div class="">
                        <label class="td-label">Postal/Zip Code:</label>
                        <input :class="[{'error': addressValidator.errors['postalCode'] || responseErrors['postal'] || addressValidator.errors['postalCodeFinal']}, 'td-input']"
                               v-model="address.postalCode" type="text" :placeholder="postalPlaceholder"
                               @input="addressValidator.validate('postalCode');clearResponseErrors('address')"
                               @blur="addressValidator.validate('postalCodeFinal')" />
                        <error v-if="addressValidator.errors['postalCode']" :error="addressValidator.errors['postalCode']"></error>
                        <error v-if="addressValidator.errors['postalCodeFinal']" :error="addressValidator.errors['postalCodeFinal']"></error>
                    </div>
                </div>
                <error v-if="responseErrors['line1']" :error="responseErrors['line1']"></error>
            </div>
        </div>

        <div class="actions">
            <div>
                <button class="td-btn primary-outlined" @click.prevent="cancel">Cancel</button>
            </div>
            <div class="save-btn">
                <button class="td-btn btn primary" @click.prevent="saveCard"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Add Credit Card</button>
            </div>
        </div>
    </div>
</template>

<script>
    import script from './AddCreditCard';
    export default script;
</script>
<style lang="less">
    @import './AddCreditCard.less';
</style>